import { request } from "services/api/util";

class OfficialWebsiteService {
  getHeaders() {
    return {
      "Accept-Language": "th",
    };
  }

  async getListUserRevocations(params) {
    return request({
      method: "get",
      url: "admin/officialWebsite/users/revocations",
      params,
      headers: this.getHeaders(),
    });
  }

  async getUserRevocationsDetail(id) {
    const config = {
      method: "get",
      url: `admin/officialWebsite/users/revocations/${id}`,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getListUserMappings(params) {
    return request({
      method: "get",
      url: "admin/officialWebsite/users/mappings",
      params,
      headers: this.getHeaders(),
    });
  }

  async getUserMappingDetail(customerNumber,brandCode) {
    const config = {
      method: "get",
      url: `admin/officialWebsite/users/mappings/${customerNumber}/${brandCode}`,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async revokeUserMapping(params) {
    return request({
      method: "post",
      url: "admin/officialWebsite/users/revocations",
      data:  params ,
      headers: this.getHeaders(),
    });
  }

  async addOfficialWebsiteOrder(params) {
    return request({
      method: "post",
      url: "admin/officialWebsite/orders",
      data:  params ,
      headers: this.getHeaders(),
    });
  }

}

export default new OfficialWebsiteService();
